import React from 'react'
import { VyneRadio } from '@vynedental/design-system'
import { RadioChangeEvent } from 'antd'

import SelfSchedulingModel from '../../../../models/SelfScheduling'

import './SelfSchedulingButtonSize.sass'

export type SelfSchedulingButtonSizeProps = {
    size: Models.SelfSchedulingButtonSize
    updateSize: (size: Models.SelfSchedulingButtonSize) => void
}

const moduleName = 'self-scheduling-button-size'

function SelfSchedulingButtonSize(props: SelfSchedulingButtonSizeProps) {
    const { size = SelfSchedulingModel.defaultButtonSize } = props

    function updateSize(e: RadioChangeEvent) {
        props.updateSize(e.target.value as Models.SelfSchedulingButtonSize)
    }

    return (
        <div className={moduleName}>
            <h3 className="webcode-section-title">Size:</h3>
            <div className={`${moduleName}__wrapper`}>
                <VyneRadio
                    dataTestId="button-size-large"
                    checked={size === 'large'}
                    onChange={updateSize}
                    name="radio-widget-style"
                    value="large"
                    isStandalone
                    style={{ marginBottom: 0 }}
                >
                    Large (min width = 277)
                </VyneRadio>
            </div>
            <div className={`${moduleName}__wrapper`}>
                <VyneRadio
                    dataTestId="button-size-medium"
                    checked={size === 'medium'}
                    onChange={updateSize}
                    name="radio-widget-style"
                    value="medium"
                    isStandalone
                    style={{ marginBottom: 0 }}
                >
                    Medium (min width = 236)
                </VyneRadio>
            </div>
            <div className={`${moduleName}__wrapper`}>
                <VyneRadio
                    dataTestId="button-size-small"
                    checked={size === 'small'}
                    onChange={updateSize}
                    name="radio-widget-style"
                    value="small"
                    isStandalone
                    style={{ marginBottom: 0 }}
                >
                    Small (min width = 209)
                </VyneRadio>
            </div>
        </div>
    )
}

export default SelfSchedulingButtonSize
